import { Route } from 'react-router-dom';
import { routes } from '../../utils/helpers/ApiClient';
import CMSWrapper from '../CMSWrapper';
import {
  SensorDetailPage,
  SensorEditPage,
  SensorsAttributesEditPage,
  SensorsAttributesPage,
  SensorsPage,
  UnitsEditPage,
  UnitsPage,
} from '../pages/CMSPages/index';
import React from 'react';

const MeteoRoutes = () => (
  <>
    <Route
      path={`${routes.cmsMeteoStationSensors}`}
      element={
        <CMSWrapper permissions={['meteo-station.index']}>
          <SensorsPage />
        </CMSWrapper>
      }
    />
    <Route
      path={routes.cmsMeteoStationSensorsDetail(':sensorId')}
      element={
        <CMSWrapper permissions={['meteo-station.show']}>
          <SensorDetailPage />
        </CMSWrapper>
      }
    />
    <Route
      path={routes.cmsMeteoStationSensorsEdit(':sensorId')}
      element={
        <CMSWrapper permissions={['meteo-station.update']}>
          <SensorEditPage />
        </CMSWrapper>
      }
    />
    <Route
      path={routes.cmsMeteoStationSensorsAttributes(':sensorId')}
      element={
        <CMSWrapper permissions={['meteo-station.index']}>
          <SensorsAttributesPage />
        </CMSWrapper>
      }
    />
    <Route
      path={routes.cmsMeteoStationSensorsAttributesCreate(':sensorId')}
      element={
        <CMSWrapper permissions={['meteo-station.store']}>
          <SensorsAttributesEditPage />
        </CMSWrapper>
      }
    />
    <Route
      path={routes.cmsMeteoStationSensorsAttributeEdit(
        ':sensorId',
        ':attributeId',
      )}
      element={
        <CMSWrapper permissions={['meteo-station.update']}>
          <SensorsAttributesEditPage />
        </CMSWrapper>
      }
    />
    <Route
      path={`${routes.cmsMeteoStationUnits}`}
      element={
        <CMSWrapper permissions={['meteo-station.index']}>
          <UnitsPage />
        </CMSWrapper>
      }
    />
    <Route
      path={`${routes.cmsMeteoStationUnitsCreate}`}
      element={
        <CMSWrapper permissions={['meteo-station.store']}>
          <UnitsEditPage />
        </CMSWrapper>
      }
    />
    <Route
      path={routes.cmsMeteoStationUnitsDetail(':attributeUnitId')}
      element={
        <CMSWrapper permissions={['meteo-station.update']}>
          <UnitsEditPage />
        </CMSWrapper>
      }
    />
  </>
);

export default MeteoRoutes;
